import React from 'react';

const Impressum = () => {
  return (
    <div>
        <div className="container w-50 mt-5 mb-5" style={{textAlign: "justify"}}>
        
        <h2 className="mb-4">Impressum</h2>
        <p>Anbieterkennzeichnung nach § 5 Abs. 1 Telemediengesetz (TMG):</p>
        <p>
            Technische Universität Dortmund<br />
            August-Schmidt-Straße 4, 44227 Dortmund<br />
            Telefon: 0231/755-1<br />
            E-Mail: presse@tu-dortmund.de<br />
        </p>
        <p>
            Die Technische Universität (TU) Dortmund ist gem. § 2 Abs. 1 Satz 1 i.V.m. § 1 Abs. 2 Satz 1 Nr. 5 des Gesetzes über die Hochschulen des Landes Nordrhein-Westfalen (HG NRW) eine vom Land Nordrhein-Westfalen getragene, rechtsfähige Körperschaft des öffentlichen Rechts. Sie wird vertreten durch die Rektorin Prof. Dr. Manfred Bayer.
        </p>
        <p>
            Die TU Dortmund nimmt ihre Aufgaben gem. § 76 Abs. 1 Satz 1 HG NRW unter der Rechtsaufsicht des Ministeriums für Kultur und Wissenschaft des Landes Nordrhein-Westfalen, Völklinger Straße 49, 40221 Düsseldorf wahr.
        </p>
        <p>Umsatzsteuer-Identifikationsnummer gem. § 27a Umsatzsteuergesetz (UStG): DE 811 258 273</p>
        <p style={{ fontWeight: 'bold', marginTop:"20px"}}>Redaktionell verantwortlich gemäß § 55 Abs. 2 des Staatsvertrages für Rundfunk und Telemedien (RStV):</p>
        <p>
            Stefan Böcker<br />
            Technische Universität Dortmund<br />
            Fakultät für Elektrotechnik und Informationstechnik<br />
            Lehrstuhl für Kommunikationsnetze<br />
            Otto-Hahn-Straße 6 <br />
            44227 Dortmund<br /><br />
            Telefon: (+49) 231-755-7004<br />
            Fax: (+49) 231 755-6136<br />
        </p>
        <p>E-Mail: stefan.boecker@tu-dortmund.de</p>

        <div className="fw-bold fs-4 mt-6 mb-3">Rechtlicher Hinweis</div>
        <p>
            Inhalte, Design und Struktur der Website der Technischen Universität Dortmund - Lehrstuhl für Kommunikationsnetze sind urheberrechtlich geschützt. Die Vervielfältigung von Informationen oder Daten, insbesondere die Verwendung von Texten, Textteilen oder Bildmaterial, bedarf der vorherigen Zustimmung der Technischen Universität Dortmund - Lehrstuhl für Kommunikationsnetze.
        </p>

        <div className="fw-bold fs-4 mt-6 mb-3">Hinweise zur Nutzung</div>
        <p>Für Vollständigkeit, Fehler redaktioneller und technischer Art, Auslassungen usw. sowie die Richtigkeit der Eintragungen kann keine Haftung übernommen werden. Insbesondere kann keine Gewähr für die Vollständigkeit und Richtigkeit von Informationen übernommen werden, die über weiterführende Links erreicht werden.</p>
        <p>Anbieter sind für die eigenen Inhalte, die sie zur Nutzung bereithalten, nach den allgemeinen Gesetzen verantwortlich. Von diesen eigenen Inhalten sind Querverweise auf die von anderen Anbietern bereitgehaltenen Inhalte zu unterscheiden.</p>
        <p>Die Verweise durch Hyperlinks auf Inhalte fremder Webseiten dienen lediglich der Information. Die Verantwortlichkeit für diese fremden Inhalte liegt allein bei dem Anbieter, der die Inhalte bereithält. Vor dem Einrichten des entsprechenden Verweises sind die Web-Seiten der anderen Anbieter mit großer Sorgfalt und nach bestem Wissen und Gewissen überprüft worden. Es kann jedoch keine Gewähr für die Vollständigkeit und Richtigkeit von Informationen übernommen werden, die über weiterführende Hyperlinks erreicht werden.</p>
        <p>Für sämtliche Links auf diesen Seiten gilt: Wir betonen, dass wir keinen Einfluss auf die Gestaltung und die Inhalte der durch Link von unserer Homepage aus erreichbaren Seiten anderer Anbieter haben und uns deren Inhalt nicht zu eigen machen. Diese Erklärung gilt für alle Seiten dieser Homepage und die dort angebrachten Links.</p>

        <div className="fw-bold fs-4 mt-6 mb-3">Urheberrecht</div>
        <p style={{ textAlign: 'justify' }} >Das Copyright für Texte und Bilder liegt, soweit nicht anders vermerkt, bei der Technischen Universität Dortmund - Lehrstuhl für Kommunikationsnetze.</p>
        </div>

   </div>
  );
};

export default Impressum;